import {Injectable, Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'filter'
})
@Injectable()
export class FilterPipe implements PipeTransform {
    transform(items: any[], field : string, value : string): any[] {
        if (!items) return [];
        if (!value || value.length == 0) return items;
        return items.filter(it =>
            it[field].toLowerCase().indexOf(value.toLowerCase()) !=-1);
    }
}



// WEBPACK FOOTER //
// ./src/pipes/filter/filter.ts